// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Dq3V","file":"styles_file__2Ajkx"};